import { CustomerDetailPage } from '@/features/companies/pages/detail-page/customer-detail';

export const CustomerDetailRoute = () => {
  return <CustomerDetailPage />;
};
